import { useNavigate } from 'react-router-dom';

import type { Go } from './types';

/** Navigation helper: push a path and scroll to top. Replaces the old `go` prop plumbing. */
export function useGo(): Go {
  const navigate = useNavigate();
  return (path: string, opts?: { state?: unknown }) => {
    navigate(path, opts);
    window.scrollTo(0, 0);
  };
}
